import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/digithia-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-331a1220"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 1,
  class: "menu-logo",
  alt: "Logo",
  src: _imports_0
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { slot: "side-bar" }
const _hoisted_8 = {
  slot: "footer",
  class: "footer"
}
const _hoisted_9 = { class: "app-links" }
const _hoisted_10 = { class: "app-footer" }
const _hoisted_11 = { class: "logged-user" }

import { useStoreAuth } from '@/store/auth'
import { USER_ROLES } from '@/model/User'
import { computed } from 'vue'
import router, { goTo } from '@/router'
import { useStoreDashboard } from '@/store/dashboard'
import { __ } from '@/locales'


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewMain',
  setup(__props) {

const storeAuth = useStoreAuth()
const storeDashboard = useStoreDashboard()
const version = '1.2.3'

const image = computed(() => storeAuth.projectImage)
const loggedUser = computed(() => storeAuth.user)
const mobile = computed(() => window.innerWidth < 600)

const logout = () => {
  storeAuth.logout()
  goTo({ name: 'Login' })
}
const goBack = () => {
  router.back()
}

const refreshJourneyAndProject = async () => {
  storeDashboard.getAllJourneys()
  storeDashboard.getAllProjects()
}

return (_ctx: any,_cache: any) => {
  const _component_dig_ui_nav_bar_item = _resolveComponent("dig-ui-nav-bar-item")!
  const _component_base_locale_select = _resolveComponent("base-locale-select")!
  const _component_dig_ui_side_bar_item = _resolveComponent("dig-ui-side-bar-item")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_dig_ui_view = _resolveComponent("dig-ui-view")!
  const _component_base_locale_popup = _resolveComponent("base-locale-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_dig_ui_view, {
      ref: "digUiView",
      "close-menu": "",
      class: "view"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_dig_ui_nav_bar_item, {
          slot: "nav-bar",
          class: "no-padding-on-desktop",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(goTo)({ name: 'Home' })))
        }, {
          default: _withCtx(() => [
            (_unref(image))
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "menu-logo",
                  alt: "Logo",
                  src: _unref(image)
                }, null, 8, _hoisted_1))
              : (_openBlock(), _createElementBlock("img", _hoisted_2))
          ]),
          _: 1
        }),
        _createVNode(_component_dig_ui_nav_bar_item, {
          slot: "nav-bar",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(goTo)('/account')))
        }, {
          default: _withCtx(() => [
            (!_unref(mobile))
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('Nav.MyAccount')), 1))
              : _createCommentVNode("", true),
            (_unref(mobile))
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('Nav.MyAccountShort')), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_dig_ui_nav_bar_item, {
          slot: "nav-bar",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (logout()))
        }, {
          default: _withCtx(() => [
            (!_unref(mobile))
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('Nav.Logout')), 1))
              : _createCommentVNode("", true),
            (_unref(mobile))
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('Nav.LogoutShort')), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_dig_ui_nav_bar_item, { slot: "nav-bar" }, {
          default: _withCtx(() => [
            _createVNode(_component_base_locale_select)
          ]),
          _: 1
        }),
        _createElementVNode("nav", _hoisted_7, [
          _createVNode(_component_dig_ui_side_bar_item, {
            class: "side-bar-title",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (goBack()))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('Nav.Previous')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_dig_ui_side_bar_item, {
            class: "side-bar-title",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(goTo)({ name: 'Home' })))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('Nav.Home')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_dig_ui_side_bar_item, {
            class: "side-bar-title",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(goTo)({ name: 'CreatePlayer' })))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('Nav.CreatePlayer')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_dig_ui_side_bar_item, {
            class: "side-bar-title",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(goTo)({ name: 'Players' })))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('Nav.Players')), 1)
            ]),
            _: 1
          }),
          (_unref(loggedUser)?.role === _unref(USER_ROLES).SUPERADMIN)
            ? (_openBlock(), _createBlock(_component_dig_ui_side_bar_item, {
                key: 0,
                class: "side-bar-title",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(goTo)({ name: 'Admins' })))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('Nav.Admins')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(loggedUser)?.role === _unref(USER_ROLES).SUPERADMIN)
            ? (_openBlock(), _createBlock(_component_dig_ui_side_bar_item, {
                key: 1,
                class: "side-bar-title",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(goTo)({ name: 'Projects' })))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('Nav.Projects')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(loggedUser)?.role === _unref(USER_ROLES).SUPERADMIN)
            ? (_openBlock(), _createBlock(_component_dig_ui_side_bar_item, {
                key: 2,
                class: "side-bar-title",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(goTo)({ name: 'Journeys' })))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('Nav.Journeys')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_router_view, { slot: "content" }),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Nav.Home')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/account" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Nav.MyAccount')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", { class: "version" }, "Mystery Tour " + _toDisplayString(version)),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(loggedUser)?.username) + " (" + _toDisplayString(_unref(loggedUser)?.role) + ") ", 1)
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_base_locale_popup, {
      langs: ['fr', 'en'],
      onUpdate: _cache[10] || (_cache[10] = ($event: any) => (refreshJourneyAndProject()))
    })
  ], 64))
}
}

})